import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

import { ArrowCounterClockwiseIcon, CaretDoubleRightIcon, TrashIcon } from '@phosphor-icons/react'

import { Button, Divider, Text } from '@reveni-io/reveni-ui'

import BlockConfigurationBreadcrumb from './BlockConfigurationBreadcrumb/BlockConfigurationBreadcrumb'
import BlockSettingsSection from './BlockSettingsSection/BlockSettingsSection'
import BlockVisibilitySection from './BlockVisibilitySection/BlockVisibilitySection'
import HiddenBlockNotice from './HiddenBlockNotice/HiddenBlockNotice'
import * as Styles from './styles'

const BlockConfigurationSidebar = ({
  definition,
  settings,
  isHidden,
  onOpenPreviewSettings,
  onChangeSetting,
  onUploadImage,
  canUploadImage,
  visibility,
  timeZone,
  onChangeVisibility,
  criteriaOptions,
  loadingCriteriaOptions,
  onGoToCriteria,
  onResetBlock,
  onRemoveBlock,
  onBack,
  onClose,
}) => {
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <Styles.Header>
        <BlockConfigurationBreadcrumb blockLabel={t(definition.label)} onBack={onBack} />
        <Button variant="text" aria-label={t('Cerrar menú de bloques')} onClick={onClose}>
          <CaretDoubleRightIcon size={20} />
        </Button>
      </Styles.Header>
      <Styles.Body>
        {isHidden && (
          <>
            <HiddenBlockNotice onOpenPreviewSettings={onOpenPreviewSettings} />
            <Divider />
          </>
        )}
        <Styles.Intro data-testid="block-configuration-intro">
          <Text type="titleM">{t(definition.label)}</Text>
          {settings.internal_name && <Text type="bodyMBold">{settings.internal_name}</Text>}
          <Styles.Description type="bodySRegular">{t(definition.description)}</Styles.Description>
        </Styles.Intro>
        {definition.settingsSections.map(section => (
          <Fragment key={section.title}>
            <Divider />
            <BlockSettingsSection
              section={section}
              settings={settings}
              onChangeSetting={onChangeSetting}
              onUploadImage={onUploadImage}
              canUploadImage={canUploadImage}
            />
          </Fragment>
        ))}
        {definition.supportsVisibility && (
          <>
            <Divider />
            <BlockVisibilitySection
              visibility={visibility}
              timeZone={timeZone}
              onChange={onChangeVisibility}
              criteriaOptions={criteriaOptions}
              loadingCriteriaOptions={loadingCriteriaOptions}
              onGoToCriteria={onGoToCriteria}
            />
          </>
        )}
      </Styles.Body>
      <Styles.Footer>
        <Button variant="text" onClick={onResetBlock}>
          <ArrowCounterClockwiseIcon size={20} />
          {t('Restablecer bloque')}
        </Button>
        <Button variant="text" color="danger" onClick={onRemoveBlock}>
          <TrashIcon size={20} />
          {t('Eliminar bloque')}
        </Button>
      </Styles.Footer>
    </Styles.Container>
  )
}

export default BlockConfigurationSidebar
